import React, {useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {Button} from "../../../buttons";
import { ReactComponent as ArrowUpCircleFilledIcon } from '../../../../assets/icons/new/UI/ArrowUpCircleFilled.svg';
import PillActionButton from '../../../StocksLayout/PillActionButton';
import {TClickHandlerMouseEvent} from "../../../buttons/types";
import stocksService from "../../../../api/services/stocksService";
import structuredClone from "@ungap/structured-clone";
import {WarehouseType} from "../../../../constants/Warehouses/WarehouseType";
import ModalBasic from "../../../commons/Modals/ModalBasic";
import {tasksService} from "../../../../api";
import {TaskStatusesList} from "../../../../api/services/tasks/models";
import stocksExportService from "../../../../api/services/stocksExportService";
import {defaultNotificationCreator} from "../../../../templates/Notifications";
import {setTemporaryNotifications} from "../../../../redux/notifications/actions";

// @ts-ignore
function ExportStocksToWarehouses({disabled}) {

    const dispatch = useAppDispatch();

    const [modalOpen, setModalOpen] = React.useState(false);
    
    const { sellerId, userId } = useAppSelector(({ sellers, users }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        userId: users.currentUser.data.id
    }))

    const [inProcessing, setInProcessing] = useState<boolean>(false)

    function clickHandler() {
        setInProcessing(true)
        if (!sellerId || !userId) {
            return;
        }

        stocksExportService.manuallyRecalcAndExport(sellerId, false, true, true, [])
            .then(
                (res) => {
                    if (res.data.success) {
                        dispatch(setTemporaryNotifications(
                            defaultNotificationCreator({
                                title: "Отправка остатков запущена",
                                description: "",
                                iconType: "success"
                            })
                        ))
                        setModalOpen(false)
                    }
                },
                (err) => {
                    dispatch(setTemporaryNotifications(
                        defaultNotificationCreator({
                            title: "Не удалось отправить остатки",
                            description: err.message(),
                            iconType: "warning"
                        })
                    ))
                }
            )
            .catch((err) => {
                dispatch(setTemporaryNotifications(
                    defaultNotificationCreator({
                        title: "Не удалось отправить остатки",
                        description: err.message,
                        iconType: "warning"
                    })
                ))
            })
            .finally(() => setInProcessing(false))
    }

    function clickHandlers() {
        clickHandler();
    }
    
    return (
        <>
            <PillActionButton
                icon={ArrowUpCircleFilledIcon}
                label="Отправить остатки"
                title={disabled ? 'Для начала настройте склад для отправки' : 'Отправить остатки'}
                disabled={disabled}
                loading={inProcessing}
                onClick={() => setModalOpen(true)}
            />
            <ModalBasic id="confirmExportStocksToWarehouses" customSize="max-w-sm" title="" modalOpen={modalOpen} setModalOpen={setModalOpen}>
                <div className={`py-5`}>
                    <div>Подтверждаете отправку остатков?</div>
                    <Button
                        appearance="primary"
                        customClassName="button-add px-[50px] mt-5"
                        clickHandler={clickHandlers}
                        loading={inProcessing}
                    >Да</Button>
                </div>
            </ModalBasic>
        </>

    );
}

export default ExportStocksToWarehouses;
